module.exports = __webpack_public_path__ + "static/img/leadingwithhearts.b24f33c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates/leadingwithhearts.png
// module id = FDrT
// module chunks = 0